import React, { useState } from "react";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { useLocation } from "react-router-dom";
import styles from "./Screen2.module.css";
import { BiCross, BiSolidPlusCircle } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { CgClose } from "react-icons/cg";
// import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
const Screen2 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isModalOpen, setIsModalOpen] = useState(
    WeddingWeb?.stories?.length > 0 ? false : true
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [id, setId] = useState();
  const [desc, setDesc] = useState("");
  const [detailsArr, setDetailsArr] = useState(
    WeddingWeb?.stories?.length > 0 ? WeddingWeb?.stories : []
  );
  // const [editItem, setEditItem] = useState();
  console.log("detailsArrr", detailsArr);
  const dispatch = useDispatch();
  const onClickNext = () => {
    if (detailsArr?.length == 0) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please Add atleast one detail",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 2,
          weddingWebId: WeddingWeb?.id,
          detailsArr,
        })
      ).then(() => setCurrentStep((prev) => prev + 1));
    }
  };
  const saveDetails = () => {
    if (!title || !desc) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      let dummyArr = [...detailsArr];
      dummyArr.push({
        id: detailsArr?.length + 1,
        title: title,
        description: desc,
      });
      setDetailsArr(dummyArr);
      setIsModalOpen(false);
      setTitle("");
      setDesc("");
      setId();
    }
  };
  const onClickEditBtn = (item) => {
    setIsEditModalOpen(true);
    setId(item?.id);
    setTitle(item?.title);
    setDesc(item?.description);
  };
  const editDetails = () => {
    let data = {
      id: id,
      title: title,
      description: desc,
    };
    let index = detailsArr.findIndex((item) => item?.id == id);
    setDetailsArr((prev) => {
      prev.splice(index, 1, data);
      return prev;
    });
    setIsEditModalOpen(false);
    setTitle("");
    setDesc("");
    setId();
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <CgClose
          className={styles.crossIcon}
          size={20}
          onClick={() => {
            setDetailsArr((prev) => {
              let newArr = [...prev];
              newArr.splice(index, 1);
              return newArr;
            });
          }}
        />
        <TextComponent text={item?.title} textClass={styles.title} />
        <TextComponent text={item?.description} textClass={styles.desc} />
        <TextComponent
          text={"Edit"}
          textClass={styles.editBtn}
          onClick={() => onClickEditBtn(item)}
        />
      </div>
    );
  };
  return (
    <>
      <div className={styles.content}>
        <div className={styles.textCont}>
          <TextComponent text={"Love Starts Here!"} />
        </div>
      </div>
      {detailsArr && (
        <div className={styles.listDiv}>
          <List
            grid={{ lg: 2, xxl: 2, xl: 2, xs: 1, md: 2, sm: 1 }}
            dataSource={detailsArr}
            renderItem={renderItem}
            className={styles.list}
          />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          <BiSolidPlusCircle className={styles.addIcon} />
          <TextComponent text={"Add"} />
        </div>
        <div className={styles.nextBtn}>
          <SubmitButton title={"Next"} onClick={onClickNext} />
        </div>
      </div>

      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        pinkBg={true}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <InputField
            placeholder={"Title"}
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
          <TextareaField
            rows={3}
            placeholder={"Write Here"}
            onChange={(e) => setDesc(e.target.value)}
            value={desc}
          />
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={saveDetails}
            />
          </div>
        </div>
      </Modal>
      <Modal
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        closable={true}
        pinkBg={true}
        onClose={() => {
          setId();
          setTitle("");
          setDesc("");
        }}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <InputField
            placeholder={"Title"}
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
          <InputField
            placeholder={"Write Here"}
            onChange={(e) => setDesc(e.target.value)}
            value={desc}
          />
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={editDetails}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Screen2;
